import Select from "react-select";
import { reactSelectSMStyle, styles } from "Utils/Common";
import useLang from "Shared/hooks/useLanguage";
import { SelectOption } from "../types";

interface StepReagentInstrumentSelectProps {
  reagentOptions: SelectOption[];
  instrumentOptions: SelectOption[];
  selectedReagent: string;
  selectedInstrument: string;
  onReagentChange: (value: string) => void;
  onInstrumentChange: (value: string) => void;
}

export function StepReagentInstrumentSelect({
  reagentOptions,
  instrumentOptions,
  selectedReagent,
  selectedInstrument,
  onReagentChange,
  onInstrumentChange,
}: StepReagentInstrumentSelectProps) {
  const { t } = useLang();

  const selectStyles = {
    ...reactSelectSMStyle,
    control: (provided: any) => ({
      ...provided,
      minWidth: "100%",
      border: "1px solid #e5e5e5",
      borderRadius: "6px",
      "&:hover": {
        border: "1px solid #e5e5e5",
      },
    }),
  };

  return (
    <div className="mt-3 d-flex gap-3">
      <div style={{ flex: 1 }}>
        <label
          className="form-label mb-1 fw-500"
          style={{ fontSize: "13px", color: "#333" }}
        >
          {t("Please select a reagent")}
        </label>
        <Select
          theme={(theme) => styles(theme)}
          options={reagentOptions}
          value={reagentOptions.find((r) => String(r.value) === selectedReagent) || null}
          styles={selectStyles}
          menuPortalTarget={document.body}
          placeholder={`--- ${t("Select")} ---`}
          isSearchable={true}
          onChange={(opt) => {
            const selected = opt as SelectOption | null;
            onReagentChange(selected ? String(selected.value) : "");
          }}
        />
      </div>
      <div style={{ flex: 1 }}>
        <label
          className="form-label mb-1 fw-500"
          style={{ fontSize: "13px", color: "#333" }}
        >
          {t("Please select an instrument")}
        </label>
        <Select
          theme={(theme) => styles(theme)}
          options={instrumentOptions}
          value={instrumentOptions.find((i) => String(i.value) === selectedInstrument) || null}
          styles={selectStyles}
          menuPortalTarget={document.body}
          placeholder={`--- ${t("Select")} ---`}
          isSearchable={true}
          onChange={(opt) => {
            const selected = opt as SelectOption | null;
            onInstrumentChange(selected ? String(selected.value) : "");
          }}
        />
      </div>
    </div>
  );
}
